import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { useToast } from '../contexts/ToastContext';

export const ANALYSIS_IN_PROGRESS_TOAST_ID = 'analysis-in-progress';

interface MobileAnalysisProgressToastProps {
  isAnalyzing: boolean;
  shouldOpenSidebar: boolean;
}

export const MobileAnalysisProgressToast: React.FC<MobileAnalysisProgressToastProps> = ({
  isAnalyzing,
  shouldOpenSidebar,
}) => {
  const { t } = useLocale();
  const { showPersistentToast, hideToast } = useToast();
  const shouldShow = isAnalyzing && !shouldOpenSidebar;

  useEffect(() => {
    if (!shouldShow) {
      hideToast(ANALYSIS_IN_PROGRESS_TOAST_ID);
      return;
    }

    showPersistentToast(
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
        {t('analysis_in_progress')}
      </span>,
      ANALYSIS_IN_PROGRESS_TOAST_ID,
    );

    return () => {
      hideToast(ANALYSIS_IN_PROGRESS_TOAST_ID);
    };
  }, [shouldShow, showPersistentToast, hideToast, t]);

  return null;
};
